var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { class: { grid: true, "grid--loading": _vm.$wait.is("events") } },
      [
        _vm.error
          ? _c("li", { staticClass: "grid__error col-12" }, [
              _c("span", { staticClass: "h2" }, [
                _vm._v("Unable to load events."),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--link",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.getEvents.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Retry")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.events.length
          ? _vm._l(_vm.events, function (event) {
              return _c(
                "li",
                { staticClass: "col-md-6 col-lg-4 col-12" },
                [
                  _c("EventCard", {
                    attrs: { "curr-event": event, flags: true },
                  }),
                ],
                1
              )
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }